<script>
    import {flip} from 'svelte/animate';
    import R, {LOADER} from "../lib/requests";
    import LocationSelect from "../components/controls/LocationSelect.svelte";
    import Alert from "../stores/alerts";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import Notifier from "../stores/notifier";

    export let value;
    export let locations;
    export let department_id = 0;

    let selectedLocations = [];
    let hovering = false;

    value.map(id => {
        let item = locations.find(x => x.id === id);
        if (item) {
            selectedLocations.push(item);
        }
    });

    const addLocation = ({detail}) => {
        selectedLocations = [...selectedLocations, detail];
    }

    const removeLocation = (location) => {
        Alert.delete("Remove Location", `Remove "${location.name}" from list?`, () => {
            selectedLocations = selectedLocations.filter(x => x.id != location.id);
        });
    }

    const getDepartmentHotels = () => {
        const onSuccess = result => {

            if (result.hotels.length == 0) {
                Alert.warning("Department", "This departed has no hotels!");
                return;
            }

            result.hotels.map(hotel => {
                let location = locations.find(x => x.hotel_id === hotel.id);
                if (location && !selectedLocations.some(item => item.id === location.id)) {
                    selectedLocations = [...selectedLocations, location];
                }
            });

            Notifier.showMessage(`Added ${result.hotels.length} locations in list`);
        };

        const onFailure = err => {
        };

        R.handle(R.department.details, department_id, onSuccess, onFailure, LOADER.POPUP);
    }

    const dragstart = (event, i) => {
        event.dataTransfer.effectAllowed = 'move';
        event.dataTransfer.dropEffect = 'move';
        event.dataTransfer.setData('text/plain', i);
    }

    const drop = (event, target) => {
        event.dataTransfer.dropEffect = 'move';
        const start = parseInt(event.dataTransfer.getData("text/plain"));
        const newTracklist = selectedLocations;

        if (start < target) {
            newTracklist.splice(target + 1, 0, newTracklist[start]);
            newTracklist.splice(start, 1);
        } else {
            newTracklist.splice(target, 0, newTracklist[start]);
            newTracklist.splice(start + 1, 1);
        }
        selectedLocations = newTracklist;
        hovering = null;
    }

    const getSelectedIds = () => {

        value = selectedLocations.map(item => {
            return item.id;
        });
        console.log("getSelectedIds", value);
    }

    $: getSelectedIds(selectedLocations);
</script>
<div class="d-flex flex-column gap-2">
    <table class="table table-list">
        <tbody>
        {#each selectedLocations as item, index (item.id)}
            <tr class="row-hover" animate:flip="{{ duration: 100 }}"
                draggable={true}
                on:dragstart={event => dragstart(event, index)}
                on:drop|preventDefault={event => drop(event, index)}
                ondragover="return false"
                on:dragenter={() => hovering = index}
                class:drag-over={hovering === index}>
                <td class="p-2">
                    {item.name}
                </td>
                <td class="button-column p-1">
                    <button class="btn-reset btn-tool pt-1" title="remove location"
                            on:click={() => removeLocation(item)}>
                        <AppIcon icon="x" size="16"/>
                    </button>
                </td>
            </tr>
        {/each}
        </tbody>
    </table>
    <LocationSelect excludeFromSelection={selectedLocations} placeholder="type location to add"
                    on:select={addLocation}/>
    <button class="btn-reset btn-link text-start" on:click={getDepartmentHotels}>Get from department</button>
</div>